const initialState = {
  selectedLogo: null,
  selectedSize: "M",
  selectedPosition: { i: 0, j: 0 },
  isOpen: false
};

export const logoSelectorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_LOGO_SELECTOR": {
      return initialState;
    }
    case "SET_LOGO_SELECTOR": {
      return { ...state, ...action.logoSelector };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/logo-selector.js